import type { InboxEntryNewReply } from '@this+that/models';

// A unit left without ids is dropped, so `newReplies` lists only units that still hold one.
export const dropNewReplyMessageIds = (
  newReplies: readonly InboxEntryNewReply[],
  messageIds: Iterable<string>,
): InboxEntryNewReply[] => {
  const dropped = new Set(messageIds);
  return newReplies.flatMap((reply) => {
    const kept = reply.messageIds.filter((id) => !dropped.has(id));
    return kept.length ? [{ ...reply, messageIds: kept }] : [];
  });
};

export const listNewReplyMessageIds = (
  newReplies: readonly InboxEntryNewReply[] | null | undefined,
): string[] => (newReplies ?? []).flatMap(({ messageIds }) => messageIds);
